import { formatDatum } from './dates'
import { fileNamePart } from './files'
import { isNachweisDocName, NACHWEIS_DOC_PREFIX } from './nachweisDocName'

const DOC_LABELS: Record<string, string> = {
  erstgespraech: "Erstgespräch",
  avgs: "AVGS",
  'bestaetigung-empty': "Trägerbestätigung (Blanko)",
  bestaetigung: "Trägerbestätigung",
  bewilligung: "Bewilligung",
  vertrag: "Vertrag",
  datenschutz: "Datenschutz-Einwilligung",
  abschlussbericht: "Abschlussbericht",
  anwesenheitsliste: "Anwesenheitsliste",
  bescheinigung: "Zertifikat",
  nachweis: "Einzelcoachingnachweis",
  teilnehmerakte: "Teilnehmerakte",
}

export function docType(row: { name: string; sheet: boolean }): string {
  if (row.sheet) return 'teilnehmerakte'
  return isNachweisDocName(row.name) ? 'nachweis' : row.name
}

export function docLabel(name: string): string {
  return DOC_LABELS[name] ?? (isNachweisDocName(name) ? DOC_LABELS.nachweis : name)
}

export function docTitle(row: { name: string; sheet: boolean; sitzungDatum: string }): string {
  if (row.sheet) return row.name
  if (!isNachweisDocName(row.name)) return docLabel(row.name)
  const erfasstAm = row.name.slice(NACHWEIS_DOC_PREFIX.length)
  const datum = row.sitzungDatum ? formatDatum(row.sitzungDatum) : formatDatum(erfasstAm.slice(0, 10)) || erfasstAm
  return `${DOC_LABELS.nachweis} ${datum}`
}

const DOC_FILE_PREFIXES: Record<string, string> = {
  erstgespraech: "Erstgespraech",
  avgs: "AVGS",
  'bestaetigung-empty': "TB-Blanko",
  bestaetigung: "TB",
  bewilligung: "Bewilligung",
  vertrag: "Vertrag",
  datenschutz: "Datenschutz-Einwilligung",
  abschlussbericht: "Abschlussbericht",
  anwesenheitsliste: "Anwesenheitsliste",
  bescheinigung: "Zertifikat",
  nachweis: "Einzelcoachingnachweis",
}

export function docFilePrefix(row: { name: string; sheet: boolean }): string {
  return row.sheet ? fileNamePart(row.name) : (DOC_FILE_PREFIXES[docType(row)] ?? fileNamePart(row.name))
}
